export function getTranslationArray<T extends string>(arr: T[], config: { [key in T]: { [key: string]: any, translation: string } }) {
    return arr.map(obj => config[obj].translation)
}